import React from 'react'
import { logoutUser } from '../utils/service'

const LogoutView = (): JSX.Element => {
  React.useEffect(() => {
    logoutUser()
  }, [])
  return <></>
}

export default LogoutView
